import React, { createContext, useContext, useState, ReactNode } from 'react';

interface PasteProgressContextType {
  progress: {
    current: number;
    total: number;
    isPasting: boolean;
  };
  updateProgress: (current: number, total: number) => void;
  resetProgress: () => void;
}

const PasteProgressContext = createContext<
  PasteProgressContextType | undefined
>(undefined);

export const PasteProgressProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [progress, setProgress] = useState({
    current: 0,
    total: 0,
    isPasting: false,
  });

  const updateProgress = (current: number, total: number) => {
    setProgress({
      current,
      total,
      isPasting: current < total,
    });
  };

  const resetProgress = () => {
    setProgress({
      current: 0,
      total: 0,
      isPasting: false,
    });
  };

  return (
    <PasteProgressContext.Provider
      value={{ progress, updateProgress, resetProgress }}
    >
      {children}
    </PasteProgressContext.Provider>
  );
};

export const usePasteProgress = (): PasteProgressContextType => {
  const context = useContext(PasteProgressContext);
  if (!context) {
    throw new Error(
      'usePasteProgress must be used within a PasteProgressProvider',
    );
  }
  return context;
};
